const TeamInfoConstants = {
  Actions: {
    FETCH_TEAM_INFO_REQUEST: 'TeamInfo/FETCH_TEAM_INFO_REQUEST',
    FETCH_TEAM_INFO_SUCCESS: 'TeamInfo/FETCH_TEAM_INFO_SUCCESS',
    FETCH_TEAM_INFO_FAILURE: 'TeamInfo/FETCH_TEAM_INFO_FAILURE',
    CLEAR_TEAM_INFO: 'TeamInfo/CLEAR_TEAM_INFO',
  },
  State: {
    TEAM_INFO_BY_WORKSPACE_SLUG: 'TEAM_INFO_BY_WORKSPACE_SLUG',
    LOADING: 'loading',
    ERROR: 'error',
  },
};

export default TeamInfoConstants;
